module.exports = "/_next/static/images/vegetables-91da1454cdb710a8b20e390079e3ef04.jpeg";